<div class="mbm-accordion" [class.mbm-accordion--expanded]="expanded()" [class.mbm-accordion--disabled]="disabled()">
  <button class="mbm-accordion-header" type="button"
    [attr.aria-expanded]="expanded()" [attr.aria-disabled]="disabled() || null" [disabled]="disabled()" (click)="toggle()">
    <span class="mbm-accordion-title">{{ title() ?? (titleKey() | translate) }}</span>
    @if (badgeCount() !== undefined) {
      <span class="mbm-accordion-badge-count">{{ badgeCount() }}</span>
    }
    <img class="mbm-accordion-chevron" src="assets/icons/chevron-down.svg" alt="" aria-hidden="true">
  </button>
  @if (expanded()) {
    <div class="mbm-accordion-content">
      @if (contentTemplate(); as template) {
        <ng-container [ngTemplateOutlet]="template"></ng-container>
      } @else {
        <ng-content></ng-content>
      }
    </div>
  }
</div>
